import { LoanInfo } from './interfaces'

const cleanLoanInfo: LoanInfo = {
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: null
  },
//   amount: null,
  annualIncome: null,
  authorizeText: false,
  dateOfBirth: '',
  firstName: '',
  lastName: '',
  mobile: '',
  deviceLatitude: null,
  deviceLongitude: null,
  ssn: null,
  channelId: 'WebPQ',
  extFaSessionId: '',
  consentIds: []
}

const exampleLoanInfo: LoanInfo = {
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: 0
  },
  amount: 0,
  annualIncome: 0,
  authorizeText: true,
  dateOfBirth: '01/01/1000',
  firstName: '',
  lastName: '',
  mobile: '123-123-1234',
  ssn: 1234,
  channelId: 'WebPQ',
  extFaSessionId: '',
  consentIds: []
}


/**
 * return a copy of clean template
 */
export const getLoanInfoCleanTemp = (): LoanInfo => {
  return Object.assign({}, JSON.parse(JSON.stringify(cleanLoanInfo)))
}

/**
 * return a copy of example template
 */
export const getLoanInfoExampleTemp = (): LoanInfo => {
  return Object.assign({}, JSON.parse(JSON.stringify(exampleLoanInfo)))
}

export const requestFullyApproved = `
{
  "address": {
      "address1": "2737 DEVONSHIRE PL 224",
      "address2": "",
      "city": "WASHINGTON",
      "state": "DC",
      "zipCode": "20008"
  },
  "amount": "2500",
  "annualIncome": "60000",
  "authorizeText": true,
  "dateOfBirth": "08/01/1994",
  "firstName": "JAMES",
  "lastName": "TUCKER",
  "mobile": "123-654-5789",
  "ssn": "6500",
  "channelId": "WebPQ",
  "extFaSessionId": "83043eb1-3236-49f2-a3e4-fe9e60f136e2"
}
`

export const jsonFullyApproved1Option = `
{
  "timestamp": 1616581983706,
  "data": {
      "loanId": 23647,
      "userId": 25708,
      "status": "PRE-APPROVED",
      "subStatus": "FULLY_APPROVED",
      "multiSubStatus": [],
      "approvedLoanAmount": 2500.0,
      "autoPayDiscount": 0.5,
      "options": [
          {
              "months": 48,
              "monthlyPayment": 64.66,
              "interest": 9.99,
              "apr": 11.04,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 4,
              "optionId": 2
          }
      ],
      "noAutoPayLoanOptions": [
          {
              "months": 48,
              "monthlyPayment": 65.28,
              "interest": 10.49,
              "apr": 11.54,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 2,
              "optionId": 4
          }
      ],
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_FA",
      "loanAcctId": "IC-1025708-01",
      "dsoLoanDecision": {
          "preferredLoanOptionPriority": 1,
          "currentLoanOptionPriority": 1,
          "preferredCpUnApprovedAmount": 0.0,
          "preferredCpApprovedAmount": 2500.0,
          "additionalCpApprovals": [],
          "isCoBorrowerAllowed": false,
          "deltaAmount": 0.0,
          "optionsFrom": "Main",
          "amountFinanced": 2500.0,
          "planCode": null
      },
      "lastActiveSessionDate": null,
      "channelId": "WebPQ",
      "raiseAlertForDpOverride": false
  },
  "errors": []
}
`

export const jsonFullyApproved2Options = `
{
  "timestamp": 1616581983706,
  "data": {
      "loanId": 23647,
      "userId": 25708,
      "status": "PRE-APPROVED",
      "subStatus": "FULLY_APPROVED",
      "multiSubStatus": [],
      "approvedLoanAmount": 2500.0,
      "autoPayDiscount": 0.5,
      "options": [
          {
              "months": 48,
              "monthlyPayment": 64.66,
              "interest": 9.99,
              "apr": 11.04,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 4,
              "optionId": 2
          },
          {
              "months": 36,
              "monthlyPayment": 82.27,
              "interest": 9.99,
              "apr": 11.36,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 3,
              "optionId": 1
          }
      ],
      "noAutoPayLoanOptions": [
          {
              "months": 48,
              "monthlyPayment": 65.28,
              "interest": 10.49,
              "apr": 11.54,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 2,
              "optionId": 4
          },
          {
              "months": 36,
              "monthlyPayment": 82.87,
              "interest": 10.49,
              "apr": 11.86,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 1,
              "optionId": 3
          }
      ],
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_FA",
      "loanAcctId": "IC-1025708-01",
      "dsoLoanDecision": {
          "preferredLoanOptionPriority": 1,
          "currentLoanOptionPriority": 1,
          "preferredCpUnApprovedAmount": 0.0,
          "preferredCpApprovedAmount": 2500.0,
          "additionalCpApprovals": [],
          "isCoBorrowerAllowed": false,
          "deltaAmount": 0.0,
          "optionsFrom": "Main",
          "amountFinanced": 2500.0,
          "planCode": null
      },
      "lastActiveSessionDate": null,
      "channelId": "WebPQ",
      "raiseAlertForDpOverride": false
  },
  "errors": []
}
`



export const jsonPartiallyApproved3Options = `{
  "timestamp": 1613483915513,
  "data": {
      "loanId": 18578,
      "userId": 20488,
      "status": "PRE-APPROVED",
      "subStatus": "PARTIALLY_APPROVED",
      "multiSubStatus": [],
      "approvedLoanAmount": 7500.0,
      "autoPayDiscount": 0.5,
      "options": [
          {
              "months": 48,
              "monthlyPayment": 195.89,
              "interest": 9.99,
              "apr": 11.56,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 4,
              "optionId": 3
          },
          {
              "months": 48,
              "monthlyPayment": 195.89,
              "interest": 9.99,
              "apr": 11.56,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 4,
              "optionId": 2
          },
          {
              "months": 36,
              "monthlyPayment": 249.23,
              "interest": 9.99,
              "apr": 12.03,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 3,
              "optionId": 1
          }
      ],
      "noAutoPayLoanOptions": [
          {
              "months": 48,
              "monthlyPayment": 197.75,
              "interest": 10.49,
              "apr": 12.07,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 2,
              "optionId": 6
          },
          {
              "months": 48,
              "monthlyPayment": 197.75,
              "interest": 10.49,
              "apr": 12.07,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 2,
              "optionId": 5
          },
          {
              "months": 36,
              "monthlyPayment": 251.04,
              "interest": 10.49,
              "apr": 12.54,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 1,
              "optionId": 4
          }
      ],
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_PA_Decision",
      "loanAcctId": "IC-1020488-01",
      "dsoLoanDecision": {
          "preferredLoanOptionPriority": 1,
          "currentLoanOptionPriority": 1,
          "preferredCpUnApprovedAmount": 500.0,
          "preferredCpApprovedAmount": 7500.0,
          "additionalCpApprovals": [],
          "isCoBorrowerAllowed": true,
          "deltaAmount": 500.0,
          "optionsFrom": "Main",
          "amountFinanced": 7500.0,
          "planCode": null
      },
      "lastActiveSessionDate": null,
      "channelId": "WebPQ",
      "raiseAlertForDpOverride": false
  },
  "errors": []
}`


export const jsonPartiallyApproved = `{
  "timestamp": 1613483915513,
  "data": {
      "loanId": 18578,
      "userId": 20488,
      "status": "PRE-APPROVED",
      "subStatus": "PARTIALLY_APPROVED",
      "multiSubStatus": [],
      "approvedLoanAmount": 7500.0,
      "autoPayDiscount": 0.5,
      "options": [
          {
              "months": 48,
              "monthlyPayment": 195.89,
              "interest": 9.99,
              "apr": 11.56,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 4,
              "optionId": 2
          },
          {
              "months": 36,
              "monthlyPayment": 249.23,
              "interest": 9.99,
              "apr": 12.03,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 3,
              "optionId": 1
          }
      ],
      "noAutoPayLoanOptions": [
          {
              "months": 48,
              "monthlyPayment": 197.75,
              "interest": 10.49,
              "apr": 12.07,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 2,
              "optionId": 4
          },
          {
              "months": 36,
              "monthlyPayment": 251.04,
              "interest": 10.49,
              "apr": 12.54,
              "isPromo": false,
              "promoApr": 0.0,
              "promoTermMonths": 0,
              "priority": 1,
              "optionType": "ICW_LOAN",
              "downPayment": 0.0,
              "minimumDownPayment": 0.0,
              "maximumDownPayment": 0.0,
              "autoPayMappingOptionId": 1,
              "optionId": 3
          }
      ],
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_PA_Decision",
      "loanAcctId": "IC-1020488-01",
      "dsoLoanDecision": {
          "preferredLoanOptionPriority": 1,
          "currentLoanOptionPriority": 1,
          "preferredCpUnApprovedAmount": 500.0,
          "preferredCpApprovedAmount": 7500.0,
          "additionalCpApprovals": [],
          "isCoBorrowerAllowed": true,
          "deltaAmount": 500.0,
          "optionsFrom": "Main",
          "amountFinanced": 7500.0,
          "planCode": null
      },
      "lastActiveSessionDate": null,
      "channelId": "WebPQ",
      "raiseAlertForDpOverride": false
  },
  "errors": []
}`


export const jsonDeclinedCoboOffer = `{
  "timestamp": 1614165404154,
  "data": {
      "loanId": 18892,
      "userId": 20831,
      "status": "PRE-APPROVED",
      "subStatus": "DECLINED_WITH_COBO_OFFER",
      "multiSubStatus": [],
      "approvedLoanAmount": 0.0,
      "autoPayDiscount": 0.5,
      "options": [],
      "noAutoPayLoanOptions": [],
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_None_Decision",
      "loanAcctId": "IC-1020831-01",
      "dsoLoanDecision": {
          "preferredLoanOptionPriority": 1,
          "currentLoanOptionPriority": 0,
          "preferredCpUnApprovedAmount": 2500.0,
          "preferredCpApprovedAmount": 0.0,
          "additionalCpApprovals": [],
          "isCoBorrowerAllowed": true,
          "deltaAmount": 2500.0,
          "optionsFrom": "Main",
          "amountFinanced": null,
          "planCode": null
      },
      "lastActiveSessionDate": null,
      "channelId": "WebPQ"
  }
}`


export const jsonNoCoborrowerOffered = `{
  "timestamp": 1613996341408,
  "data": {
      "loanId": 18673,
      "userId": 20588,
      "status": "DECLINED",
      "subStatus": "NO_COBORROWER_OFFERED",
      "multiSubStatus": null,
      "approvedLoanAmount": 0.0,
      "originationFee": 0.0,
      "autoPayDiscount": 0.0,
      "originationAmount": 0.0,
      "options": null,
      "noAutoPayLoanOptions": null,
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_None",
      "loanAcctId": null,
      "dsoLoanDecision": null,
      "lastActiveSessionDate": "02/17/2021",
      "channelId": null,
      "raiseAlertForDpOverride": false
  },
  "errors": [
      {
          "code": "IC-1008",
          "message": "Existing user"
      }
  ]
}`

export const jsonNoCoborrowerOffered2 = `{
  "timestamp": 1613482856788,
  "data": {
      "loanId": 18559,
      "userId": 20466,
      "status": "DECLINED",
      "subStatus": "NO_COBORROWER_OFFERED",
      "multiSubStatus": null,
      "approvedLoanAmount": 0.0,
      "originationFee": 0.0,
      "autoPayDiscount": 0.0,
      "originationAmount": 0.0,
      "options": null,
      "noAutoPayLoanOptions": null,
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_None",
      "loanAcctId": null,
      "dsoLoanDecision": null,
      "lastActiveSessionDate": "02/16/2021",
      "channelId": null,
      "raiseAlertForDpOverride": false
  },
  "errors": [
      {
          "code": "IC-1008",
          "message": "Existing user"
      }
  ]
}`


export const jsonWelcomeBackScreen = `{
  "timestamp": 1619616236424,
  "data": {
      "loanId": 18616,
      "userId": 22756,
      "status": "PRE-APPROVED",
      "subStatus": "DECLINED_WITH_COBO_OFFER",
      "multiSubStatus": null,
      "approvedLoanAmount": 0.0,
      "originationFee": 0.0,
      "autoPayDiscount": 0.0,
      "originationAmount": 0.0,
      "options": null,
      "noAutoPayLoanOptions": null,
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_None_Decision",
      "loanAcctId": null,
      "dsoLoanDecision": null,
      "lastActiveSessionDate": "04/28/2021",
      "channelId": null,
      "raiseAlertForDpOverride": false
  },
  "errors": [
      {
          "code": "IC-1008",
          "message": "Existing user"
      }
  ]
}`

export const jsonDeclinedCoboOfferCreditFreeze = `{
  "timestamp": 1614165404154,
  "data": {
      "loanId": 18892,
      "userId": 20831,
      "status": "PRE-APPROVED",
      "subStatus": "DECLINED_WITH_COBO_OFFER",
      "multiSubStatus": [],
      "approvedLoanAmount": 0.0,
      "autoPayDiscount": 0.5,
      "options": [],
      "noAutoPayLoanOptions": [],
      "creditLockBureaus": null,
      "nextStep": "Pre_LO_Credit_Freeze",
      "loanAcctId": "IC-1020831-01",
      "dsoLoanDecision": {
          "preferredLoanOptionPriority": 1,
          "currentLoanOptionPriority": 0,
          "preferredCpUnApprovedAmount": 2500.0,
          "preferredCpApprovedAmount": 0.0,
          "additionalCpApprovals": [],
          "isCoBorrowerAllowed": true,
          "deltaAmount": 2500.0,
          "optionsFrom": "Main",
          "amountFinanced": null,
          "planCode": null
      },
      "lastActiveSessionDate": null,
      "channelId": "WebPQ"
  }
}`
